<template>
  <div class="about">
    <!-- 顶部标题区域 -->
    <section class="products-header">
      <div class="container">
        <h1 class="page-title">
          <span class="title-glow">关于我们</span>
        </h1>
        <p class="page-subtitle">以客户为中心，以创新为驱动</p>
      </div>
    </section>

    <div v-if="error" class="about-error">
      <p>{{ error }}</p>
    </div>

    <!-- 关于企业介绍 -->
    <section id="company-intro" class="about-intro-section">
      <div class="container">
        <h2 class="section-title animate-fade-in-up">企业介绍</h2>
        <div class="about-intro-content">
          <div class="about-intro-text animate-slide-in-left">
            <div class="about-intro-subtitle">{{ hero.tagline }}</div>
            <p class="about-intro-description" v-for="(item, index) in hero.description" :key="index">{{ item }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业历程 -->
    <!-- <section id="timeline" class="history-section">
      <div class="container">
        <h2 class="section-title animate-fade-in-up section-title_history">企业历程</h2>
        <div class="timeline-container">
          <div class="timeline-line"></div>
          <div 
            v-for="(event, index) in historyEvents" 
            :key="index"
            class="timeline-item animate-fade-in-up"
            :class="{ 'top': index % 2 === 0, 'bottom': index % 2 === 1 }"
            :style="{ 
              left: historyEvents.length > 1 
                ? `calc(40px + ${(index / (historyEvents.length - 1))} * (100% - 80px))` 
                : '50%',
              animationDelay: `${index * 0.15}s` 
            }"
          >
            <div class="timeline-connector"></div>
            <div class="timeline-dot" :class="{ 'blue': index % 2 === 0, 'orange': index % 2 === 1 }"></div>
            <div class="timeline-content">
              <div class="timeline-year">{{ event.year }}年</div>
              <div class="timeline-description">{{ event.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- 企业文化 -->
    <section id="culture" class="culture-section">
      <div class="container">
        <div class="culture-header">
          <h2 class="section-title culture-section-title animate-fade-in-up">企业文化</h2>
          <div class="culture-mission-vision animate-fade-in-up">
            <p class="culture-mission">"以客户为中心、创新为驱动、真诚为底色"</p>
            <p class="culture-vision">"以科技创新赋能产业，成为用户可信赖的数字化运营服务商"</p>
          </div>
        </div>
        <div class="culture-content">
          <div 
            v-for="(item, index) in cultureItems" 
            :key="index"
            class="culture-item animate-fade-in-up"
            :style="{ animationDelay: `${index * 0.15}s` }"
          >
            <div class="culture-item-bg" :style="{ backgroundImage: `url(${item.bgImage})` }"></div>
            <div class="culture-item-overlay"></div>
            <div class="culture-item-content">
              <h3 class="culture-item-title">{{ item.title }}</h3>
              <div class="culture-item-descriptions">
                <p v-for="(desc, descIndex) in item.descriptions" :key="descIndex">{{ desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 荣誉资质 -->
    <!-- <section id="honors" class="honors-section">
      <div class="honors-background">
        <span class="honors-shape honors-shape--triangle"></span>
        <span class="honors-shape honors-shape--circle"></span>
        <span class="honors-shape honors-shape--diamond"></span>
      </div>
      <div class="container">
        <h2 class="section-title animate-fade-in-up honors-section-title">荣誉资质</h2>
        <div class="honors-tabs" v-if="honorTabs.length">
          <button 
            v-for="(tab, index) in honorTabs" 
            :key="index"
            class="honor-tab"
            :class="{ active: activeTab === index }"
            @click="activeTab = index"
          >
            {{ tab.name }}
          </button>
        </div>
        <div class="honors-content" v-if="honorTabs.length">
          <transition name="fade" mode="out-in">
            <div :key="activeTab" class="honor-panel">
              <div
                v-if="
                  honorTabs[activeTab] &&
                  honorTabs[activeTab].items &&
                  honorTabs[activeTab].items.length &&
                  honorTabs[activeTab].items[0].image
                "
                class="certificates-grid certificates-photos"
              >
                <div 
                  v-for="(photo, photoIndex) in honorTabs[activeTab].items" 
                  :key="photoIndex"
                  class="certificate-photo-card animate-zoom-in"
                  :style="{ animationDelay: `${photoIndex * 0.1}s` }"
                >
                  <img :src="resolveHonorImage(photo.image)" :alt="photo.alt || `${honorTabs[activeTab].name} ${photoIndex + 1}`" />
                  <div class="certificate-name" v-if="photo.title">{{ photo.title }}</div>
                </div>
              </div>
              <div v-else-if="honorTabs[activeTab]" class="certificates-grid">
                <div 
                  v-for="(cert, certIndex) in honorTabs[activeTab].items" 
                  :key="certIndex"
                  class="certificate-card animate-zoom-in"
                  :style="{ animationDelay: `${certIndex * 0.1}s` }"
                >
                  <div class="cert-icon">{{ cert.icon }}</div>
                  <h3>{{ cert.title }}</h3>
                  <p>{{ cert.description }}</p>
                  <div class="cert-badge" v-if="cert.badge">{{ cert.badge }}</div>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div v-else class="honors-empty">
          <p v-if="loading">荣誉信息加载中...</p>
          <p v-else>暂无荣誉信息</p>
        </div>
      </div>
    </section> -->

    <!-- 客户案例 -->
    <!-- <section id="customers" class="customers-section">
      <div class="container">
        <div class="customers-header">
          <h2 class="section-title customers-section-title animate-fade-in-up">客户案例</h2>
          <p class="customers-subtitle animate-fade-in-up">服务覆盖政务、金融、企业等重点领域，为众多知名机构提供专业的数字化解决方案</p>
        </div>
        <div class="customers-content">
          <div 
            v-for="(category, categoryIndex) in customerCases" 
            :key="categoryIndex"
            class="customer-category animate-fade-in-up"
            :style="{ animationDelay: `${categoryIndex * 0.1}s` }"
          >
            <div class="customer-category-title">
              <span class="customer-category-icon" aria-hidden="true">
                <i class="iconfont" :class="getCustomerIcon(category, categoryIndex)"></i>
              </span>
              <span>{{ category.name }}</span>
            </div>
            <ul class="customer-text-list">
              <li 
                v-for="(customer, customerIndex) in category.customers" 
                :key="customerIndex"
                class="customer-text-item"
              >
                {{ customer }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section> -->

    <!-- 客户案例 -->
    <!-- <section id="customers" class="customers-section">
      <div class="container">
        <div class="customers-header">
          <h2 class="section-title customers-section-title animate-fade-in-up">客户案例</h2>
          <p class="customers-subtitle animate-fade-in-up">服务覆盖政府、金融、医疗、教育、企业等五大领域，为众多知名机构提供专业的数字化解决方案</p>
        </div>
        <div class="customers-content">
          <div 
            v-for="(category, categoryIndex) in customerCases" 
            :key="categoryIndex"
            class="customer-category"
          >
            <h3 class="customer-category-title">{{ category.name }}</h3>
            <div class="customer-list">
              <div 
                v-for="(customer, customerIndex) in category.customers" 
                :key="customerIndex"
                class="customer-item animate-fade-in-up"
                :style="{ animationDelay: `${categoryIndex * 0.1 + customerIndex * 0.05}s` }"
              >
                <div class="customer-logo">
                  <img v-if="customer.logo" :src="customer.logo" :alt="customer.name" />
                  <div v-else class="customer-logo-placeholder">{{ customer.name.charAt(0) }}</div>
                </div>
                <div class="customer-name">{{ customer.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- 人才招聘 -->
    <section id="careers" class="careers-section">
      <div class="container">
        <h2 class="section-title animate-fade-in-up">人才招聘</h2>
        <div class="careers-entry animate-zoom-in">
          <div class="entry-left">
            <div class="entry-badge">{{ careersSection.badge }}</div>
            <h3>{{ careersSection.headline }}</h3>
            <p>{{ careersSection.description }}</p>
            <router-link class="entry-btn" :to="careersSection.ctaLink || '/about/careers'">
              {{ careersSection.ctaText || '查看招聘岗位' }}
            </router-link>
          </div>
          <div class="entry-right">
            <img class="entry-illustration_img" src="../../assets/background_img/加入我们.jpg" alt="Careers illustration">
            <!-- <div class="entry-figure">
              <img class="entry-illustration" src="https://images.unsplash.com/illustration-technology?auto=format&fit=crop&w=900&q=80" alt="Careers illustration" />
            </div> -->
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section id="contact-us" class="contact-us-section">
      <div class="container">
        <h2 class="section-title animate-fade-in-up">联系我们</h2>
        <div class="contact-us-content animate-zoom-in">
          <div class="company-info-section">
            <h3 class="company-name">福建三体星云信息科技有限公司</h3>
            <div class="headquarters-info">
              <div class="headquarters-item">
                <span class="headquarters-label">服务热线：</span>
                <a href="tel:4008255199" class="headquarters-value">4008-255-199</a>
              </div>
              <div class="headquarters-item">
                <span class="headquarters-label">服务邮箱：</span>
                <a href="mailto:Services@3Clouds.cn" class="headquarters-value">Services@3Clouds.cn</a>
              </div>
              <div class="headquarters-item">
                <span class="headquarters-label">福州总部：</span>
                <span class="headquarters-value">福州市鼓楼区乌山西路518号新能源科创中心9层01-3单元</span>
              </div>
            </div>
          </div>
          <div class="branches-section">
            <h4 class="branches-title">分支机构</h4>
            <div class="branches-list">
              <div class="branch-item">
                <div class="branch-name">厦门公司：</div>
                <div class="branch-address">厦门市软件园二期望海路65号楼之二806室</div>
              </div>
              <div class="branch-item">
                <div class="branch-name">成都公司：</div>
                <div class="branch-address">成都市成华区建设路2号国光大厦5层</div>
              </div>
              <div class="branch-item">
                <div class="branch-name">联合研发中心：</div>
                <div class="branch-address">福州大学国家大学科技园（旗山校区）8号楼4层南区</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 客服热线 -->
    <!-- <section id="contact" class="customer-service-section">
      <div class="service-container">
        <div class="service-background">
          <div class="service-wave"></div>
          <div class="service-dots"></div>
        </div>
        <div class="service-content-wrapper">
          <div class="service-left-content">
            <div class="service-icon-wrapper">
              <div class="service-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 5C3 3.89543 3.89543 3 5 3H8.27924C8.70967 3 9.09181 3.27543 9.22792 3.68377L10.7257 8.17721C10.8831 8.64932 10.6694 9.16531 10.2243 9.38787L7.96701 10.5165C9.06925 12.9612 11.0388 14.9308 13.4835 16.033L14.6121 13.7757C14.8347 13.3306 15.3507 13.1169 15.8228 13.2743L20.3162 14.7721C20.7246 14.9082 21 15.2903 21 15.7208V19C21 20.1046 20.1046 21 19 21H18C9.71573 21 3 14.2843 3 6V5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="service-icon-ring"></div>
            </div>
            <div class="service-text-content">
              <h2 class="service-main-title">{{ serviceHotline.title }}</h2>
              <p class="service-subtitle">{{ serviceHotline.subtitle }}</p>
            </div>
          </div>
          <div class="service-right-content">
            <div class="service-phone-wrapper">
              <div class="service-phone-icon">📞</div>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 5C3 3.89543 3.89543 3 5 3H8.27924C8.70967 3 9.09181 3.27543 9.22792 3.68377L10.7257 8.17721C10.8831 8.64932 10.6694 9.16531 10.2243 9.38787L7.96701 10.5165C9.06925 12.9612 11.0388 14.9308 13.4835 16.033L14.6121 13.7757C14.8347 13.3306 15.3507 13.1169 15.8228 13.2743L20.3162 14.7721C20.7246 14.9082 21 15.2903 21 15.7208V19C21 20.1046 20.1046 21 19 21H18C9.71573 21 3 14.2843 3 6V5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div class="service-phone-info">
                <span class="service-phone-label">{{ serviceHotline.phoneLabel }}</span>
                <span class="service-phone-number">{{ serviceHotline.phoneNumber }}</span>
              </div>
            </div>
            <button class="service-consult-btn" @click="consultNow">
              <span>{{ serviceHotline.consultText }}</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import axios from 'axios'

const FALLBACK_CUSTOMER_ICONS = ['icon-zhengwu', 'icon-jinrong', 'icon-qiyexinxi']
const DEFAULT_CUSTOMER_ICONS = {
  '政务类客户': 'icon-zhengwu',
  '政务客户': 'icon-zhengwu',
  '金融类客户': 'icon-jinrong',
  '金融客户': 'icon-jinrong',
  '企业类客户': 'icon-qiyexinxi',
  '企业客户': 'icon-qiyexinxi'
}

// 使用 require.context 让 webpack 在打包时收集证书、奖杯和合作伙伴图片资源
const companyCertCtx = require.context('@/assets/CompanyQualifications_photo', false, /\.png$/)
const trophyPhotoCtx = require.context('@/assets/Trophy_photo', false, /\.jpe?g$/)
const partnerIconCtx = require.context('@/assets/Partner_icon', false, /\.png$/)

export default {
  name: 'About',
  data() {
    return {
      activeTab: 0,
      loading: false,
      error: null,
      hero: {},
      heroLoading: false,
      heroError: null,
      cultureItems: [],
      cultureLoading: false,
      cultureError: null,
      honorTabs: [],
      honorsLoading: false,
      honorsError: null,
      historyEvents: [],
      historyLoading: false,
      historyError: null,
      customerCases: [],
      customersLoading: false,
      customersError: null,
      careersSection: {},
      careersLoading: false,
      careersError: null,
      serviceHotline: {},
      serviceLoading: false,
      serviceError: null
    }
  },
  async mounted() {
    // 获取所有关于我们数据
    await Promise.all([
      this.fetchIntro(),
      this.fetchCulture(),
      this.fetchHonors(),
      this.fetchHistory(),
      this.fetchCustomers(),
      this.fetchCareers(),
      this.fetchService()
    ])
  },
  methods: {
    async fetchIntro() {
      try {
        this.heroLoading = true
        this.heroError = null
        const response = await axios.get('/api/about/intro')
        if (response.data.code === 200) {
          this.hero = response.data.data
        } else {
          this.heroError = response.data.message || '获取企业介绍失败'
          this.hero = {}
        }
      } catch (error) {
        console.error('获取企业介绍失败:', error)
        this.heroError = '网络请求失败，请检查服务器是否运行'
        this.hero = {}
      } finally {
        this.heroLoading = false
      }
    },
    async fetchCulture() {
      try {
        this.cultureLoading = true
        this.cultureError = null
        const response = await axios.get('/api/about/culture')
        if (response.data.code === 200) {
          this.cultureItems = Array.isArray(response.data.data) ? response.data.data : []
        } else {
          this.cultureError = response.data.message || '获取企业文化失败'
          this.cultureItems = []
        }
      } catch (error) {
        console.error('获取企业文化失败:', error)
        this.cultureError = '网络请求失败，请检查服务器是否运行'
        this.cultureItems = []
      } finally {
        this.cultureLoading = false
      }
    },
    async fetchHonors() {
      try {
        this.honorsLoading = true
        this.honorsError = null
        const response = await axios.get('/api/about/honors')
        if (response.data.code === 200) {
          this.honorTabs = Array.isArray(response.data.data) ? response.data.data : []
          if (this.activeTab >= this.honorTabs.length) {
            this.activeTab = 0
          }
        } else {
          this.honorsError = response.data.message || '获取荣誉资质失败'
          this.honorTabs = []
        }
      } catch (error) {
        console.error('获取荣誉资质失败:', error)
        this.honorsError = '网络请求失败，请检查服务器是否运行'
        this.honorTabs = []
      } finally {
        this.honorsLoading = false
      }
    },
    async fetchHistory() {
      try {
        this.historyLoading = true
        this.historyError = null
        const response = await axios.get('/api/about/history')
        if (response.data.code === 200) {
          this.historyEvents = Array.isArray(response.data.data) ? response.data.data : []
        } else {
          this.historyError = response.data.message || '获取发展历程失败'
          this.historyEvents = []
        }
      } catch (error) {
        console.error('获取发展历程失败:', error)
        this.historyError = '网络请求失败，请检查服务器是否运行'
        this.historyEvents = []
      } finally {
        this.historyLoading = false
      }
    },
    async fetchCustomers() {
      try {
        this.customersLoading = true
        this.customersError = null
        const response = await axios.get('/api/about/customers')
        if (response.data.code === 200) {
          this.customerCases = Array.isArray(response.data.data) ? response.data.data : []
        } else {
          this.customersError = response.data.message || '获取客户案例失败'
          this.customerCases = []
        }
      } catch (error) {
        console.error('获取客户案例失败:', error)
        this.customersError = '网络请求失败，请检查服务器是否运行'
        this.customerCases = []
      } finally {
        this.customersLoading = false
      }
    },
    async fetchCareers() {
      try {
        this.careersLoading = true
        this.careersError = null
        const response = await axios.get('/api/about/careers')
        if (response.data.code === 200) {
          this.careersSection = response.data.data || {}
        } else {
          this.careersError = response.data.message || '获取招聘信息失败'
          this.careersSection = {}
        }
      } catch (error) {
        console.error('获取招聘信息失败:', error)
        this.careersError = '网络请求失败，请检查服务器是否运行'
        this.careersSection = {}
      } finally {
        this.careersLoading = false
      }
    },
    async fetchService() {
      try {
        this.serviceLoading = true
        this.serviceError = null
        const response = await axios.get('/api/about/service')
        if (response.data.code === 200) {
          this.serviceHotline = response.data.data || {}
        } else {
          this.serviceError = response.data.message || '获取客服信息失败'
          this.serviceHotline = {}
        }
      } catch (error) {
        console.error('获取客服信息失败:', error)
        this.serviceError = '网络请求失败，请检查服务器是否运行'
        this.serviceHotline = {}
      } finally {
        this.serviceLoading = false
      }
    },
    consultNow() {
      const phone = (this.serviceHotline.phoneNumber || '4008-255-199').replace(/\s+/g, '')
      window.open(`tel:${phone}`)
    },
    getCustomerIcon(category, index = 0) {
      const name = category && typeof category.name === 'string' ? category.name.trim() : ''
      const icon = category && typeof category.icon === 'string' ? category.icon.trim() : ''

      if (name === '医疗类客户') {
        const medicalIcon = icon || 'icon-yiliaoweisheng-'
        return `iconfont-medical ${medicalIcon}`.trim()
      }

      if (icon.startsWith('icon-')) {
        return icon
      }
      if (icon && DEFAULT_CUSTOMER_ICONS[icon]) {
        return DEFAULT_CUSTOMER_ICONS[icon]
      }
      if (name && DEFAULT_CUSTOMER_ICONS[name]) {
        return DEFAULT_CUSTOMER_ICONS[name]
      }
      return FALLBACK_CUSTOMER_ICONS[index] || FALLBACK_CUSTOMER_ICONS[0]
    },
    resolveHonorImage(imagePath) {
      if (!imagePath) return ''
      // JSON 中配置的是 "@/assets/xxx/filename.png"
      if (imagePath.startsWith('@/assets/CompanyQualifications_photo/')) {
        const fileName = imagePath.split('/').pop()
        try {
          return companyCertCtx('./' + fileName)
        } catch (e) {
          console.warn('公司资质图片未找到:', fileName, e)
          return ''
        }
      }
      // 荣誉奖杯照片 "@/assets/Trophy_photo/xxx.jpg"
      if (imagePath.startsWith('@/assets/Trophy_photo/')) {
        const fileName = imagePath.split('/').pop()
        try {
          return trophyPhotoCtx('./' + fileName)
        } catch (e) {
          console.warn('荣誉奖杯图片未找到:', fileName, e)
          return ''
        }
      }
      if (imagePath.startsWith('@/assets/Partner_icon/')) {
        const fileName = imagePath.split('/').pop()
        try {
          return partnerIconCtx('./' + fileName)
        } catch (e) {
          console.warn('合作伙伴图片未找到:', fileName, e)
          return ''
        }
      }
      // 其他情况直接返回原路径（例如将来改为公网 URL）
      return imagePath
    }
  }
}
</script>

<style scoped>
.about {
  /* min-height: 100vh; */
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.about-error {
  max-width: 1200px;
  margin: 20px auto 0;
  padding: 12px 18px;
  border-radius: 8px;
  background: #ffecec;
  color: #c0392b;
  text-align: center;
  box-shadow: 0 4px 12px rgba(192, 57, 43, 0.15);
}

/* 顶部标题区域（复用 Products 风格） */
.products-header {
  position: relative;
  background-image: 
    url('../../assets/background_header/关于我们.png');
    /* linear-gradient(135deg, #0a0e27 0%, #1a1f3a 50%, #0f1419 100%); */
  background-size: cover, 100%;
  background-position: center, center;
  background-blend-mode: overlay;
  padding: 45px 0;
  overflow: hidden;
  min-height: 200px;
  display: flex;
  align-items: center;
}

.products-header .container {
  position: relative;
  z-index: 2;
  width: 100%;
  margin: 0;
  padding: 0 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
}

.page-title {
  position: relative;
  z-index: 2;
  margin: 0;
  text-align: left;
  padding: 0;
}

.page-subtitle {
  margin: 8px 0 0 0;
  text-align: left;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  font-style: italic;
  line-height: 1.8;
  opacity: 1;
  max-width: 900px;
  margin-left: 2em;
  position: relative;
  z-index: 2;
  backdrop-filter: blur(5px);
}

.title-glow {
  display: inline-block;
  font-size: 46px;
  font-weight: 900;
  font-family: 'Arial Black', 'Microsoft YaHei', sans-serif;
  letter-spacing: 5px;
  color: #ffffff;
  filter: drop-shadow(0 0 10px rgba(96, 165, 250, 0.6));
  position: relative;
  backdrop-filter: blur(5px);
}

@keyframes gradient-shift {
  0%, 100% { background-position: 0% center; }
  50% { background-position: 100% center; }
}

@media (max-width: 768px) {
  .page-subtitle {
    margin-left: 1.5em;
  }
}


.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 20px;
}

.section-title {
  text-align: left;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
  position: relative;
  padding-bottom: 20px;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  transform: none;
  width: 80px;
  height: 4px;
  background: linear-gradient(135deg, #4c95e3 0%, #1e55a2 100%);
  border-radius: 2px;
}

/* 企业历程部分 */
.history-section {
  position: relative;
  padding: 40px 0;
  padding-bottom: 100px;
  overflow-x: hidden;
  overflow-y: hidden;
}

.history-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1920&q=80');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  animation: kenburns-top 10s ease-out infinite alternate;
  z-index: 0;
}

.history-section::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background: linear-gradient(135deg, rgba(232, 242, 252, 0.85) 0%, rgba(197, 223, 245, 0.85) 100%); */
  z-index: 1;
}

.section-title_history{
  color: white;
}

.history-section .container {
  position: relative;
  z-index: 2;
}

.timeline-container {
  position: relative;
  max-width: 1600px;
  margin: 0 auto;
  margin-top: 100px;
  padding: 150px 40px 150px;
  min-height: 500px;
}

.timeline-line {
  position: absolute;
  left: 40px;
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
  height: 4px;
  background: linear-gradient(90deg, #4c95e3 0%, #1e55a2 100%);
  border-radius: 2px;
  z-index: 1;
}

.timeline-item {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.timeline-connector {
  position: absolute;
  left: 50%;
  width: 2px;
  height: 120px;
  background: #4c95e3;
  z-index: 1;
  transform: translateX(-50%);
}

.timeline-item.top .timeline-connector {
  bottom: 50%;
  background: linear-gradient(180deg, rgba(76, 149, 227, 0.3) 0%, #4c95e3 100%);
}

.timeline-item.bottom .timeline-connector {
  top: 50%;
  background: linear-gradient(180deg, #4c95e3 0%, rgba(76, 149, 227, 0.3) 100%);
}

.timeline-dot {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 4px solid white;
  box-shadow: 0 0 0 3px #4c95e3;
  z-index: 3;
  transition: all 0.3s ease;
}

.timeline-item:hover .timeline-dot {
  transform: translate(-50%, -50%) scale(1.3);
  box-shadow: 0 0 0 5px rgba(76, 149, 227, 0.3);
}

.timeline-dot.blue {
  background: #4c95e3;
}

.timeline-dot.orange {
  background: #ff6b6b;
}

.timeline-content {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.5);
  padding: 20px 18px;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  width: 200px;
  text-align: center;
  z-index: 2;
}

.timeline-item.top .timeline-content {
  bottom: 140px;
}

.timeline-item.bottom .timeline-content {
  top: 140px;
}

.timeline-content:hover {
  transform: translateX(-50%) translateY(-5px);
  box-shadow: 0 10px 30px rgba(76, 149, 227, 0.25);
}

.timeline-year {
  font-size: 20px;
  font-weight: bold;
  color: #fffdfd;
  margin-bottom: 10px;
  white-space: nowrap;
}

.timeline-description {
  font-size: 13px;
  color: #ffffff;
  line-height: 1.6;
  text-align: left;
}

/* 企业文化区域 */
.culture-section {
  position: relative;
  background: #ffffff;
  padding: 20px 0;
  overflow: hidden;
}

.culture-header {
  text-align: left;
  margin-bottom: 30px;
  position: relative;
  z-index: 1;
}

.culture-section-title {
  font-size: 32px;
  font-weight: 700;
  color: #333;
  position: relative;
  z-index: 1;
}

.culture-mission-vision {
  margin-top: 20px;
}

.culture-mission,
.culture-vision {
  text-align: left;
  font-size: 16px;
  color: #666;
  font-style: italic;
  line-height: 1.8;
  margin: 0 0 12px 0;
  max-width: 900px;
}

.culture-content {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  position: relative;
  z-index: 1;
}

.culture-item {
  position: relative;
  height: 500px;
  border-radius: 12px;
  overflow: hidden;
  opacity: 0;
  transition: all 0.4s ease;
  cursor: pointer;
}

.culture-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.culture-item-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: transform 0.6s ease;
}

.culture-item:hover .culture-item-bg {
  transform: scale(1.1);
}

.culture-item-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, 
    rgba(0, 0, 0, 0.2) 0%, 
    rgba(0, 0, 0, 0.4) 50%,
    rgba(0, 0, 0, 0.7) 100%);
  z-index: 1;
}

/* 偶数卡片（2、4）遮罩层 - 底部深色 */
.culture-item:nth-child(even) .culture-item-overlay {
  background: linear-gradient(to bottom, 
    rgba(0, 0, 0, 0.2) 0%, 
    rgba(0, 0, 0, 0.4) 50%,
    rgba(0, 0, 0, 0.7) 100%);
}

/* 奇数卡片（1、3）遮罩层 - 顶部深色 */
.culture-item:nth-child(odd) .culture-item-overlay {
  background: linear-gradient(to bottom, 
    rgba(0, 0, 0, 0.7) 0%, 
    rgba(0, 0, 0, 0.4) 50%,
    rgba(0, 0, 0, 0.2) 100%);
}

.culture-item-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 40px 30px;
  z-index: 2;
}

/* 奇数卡片（1、3）文字在顶部 */
.culture-item:nth-child(odd) .culture-item-content {
  top: 0;
  bottom: auto;
}

.culture-item-title {
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 25px 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  line-height: 1.2;
}

.culture-item-descriptions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.culture-item-descriptions p {
  font-size: 15px;
  color: #ffffff;
  line-height: 1.7;
  margin: 0;
  text-shadow: 0 1px 5px rgba(0, 0, 0, 0.5);
}

/* 荣誉资质部分 */
.honors-section {
  position: relative;
  padding: 20px 0;
  overflow: hidden;
  background: linear-gradient(135deg, #f7f9fc 0%, #e9eef5 40%, #ffffff 100%);
}

.honors-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 1;
}

.honors-background::before,
.honors-background::after {
  content: '';
  position: absolute;
  pointer-events: none;
}

/* 左上角柔和高光 */
.honors-background::before {
  top: -20%;
  left: -15%;
  width: 60%;
  height: 60%;
  background: radial-gradient(circle at center, rgba(255,255,255,0.9) 0%, rgba(233,238,245,0.6) 40%, rgba(233,238,245,0) 70%);
}

/* 右下角淡淡阴影，增强层次 */
.honors-background::after {
  right: -20%;
  bottom: -15%;
  width: 65%;
  height: 65%;
  background: radial-gradient(circle at center, rgba(204,213,225,0.4) 0%, rgba(204,213,225,0.15) 45%, rgba(204,213,225,0) 75%);
}

.honors-shape {
  position: absolute;
  display: block;
  pointer-events: none;
  opacity: 0.85;
  filter: drop-shadow(0 16px 26px rgba(17, 37, 79, 0.18));
  z-index: 0;
}

.honors-shape--triangle {
  top: -40px;
  right: 10%;
  width: 220px;
  height: 220px;
  background: linear-gradient(140deg, rgba(255, 255, 255, 0.92) 0%, rgba(205, 219, 239, 0.55) 40%, rgba(190, 207, 233, 0.35) 100%);
  clip-path: polygon(10% 0%, 100% 15%, 40% 100%);
  border: 1px solid rgba(96, 118, 161, 0.18);
}

.honors-shape--circle {
  width: 280px;
  height: 280px;
  bottom: -140px;
  left: 12%;
  border-radius: 50%;
  background: radial-gradient(circle at 35% 35%, rgba(255, 255, 255, 0.95) 0%, rgba(205, 215, 233, 0.6) 55%, rgba(205, 215, 233, 0.2) 78%, rgba(205, 215, 233, 0) 100%);
  border: 1px solid rgba(170, 186, 213, 0.3);
}

.honors-shape--diamond {
  width: 200px;
  height: 200px;
  top: 28%;
  left: 48%;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.85) 0%, rgba(209, 221, 239, 0.55) 55%, rgba(197, 211, 235, 0.25) 100%);
  transform: translate(-50%, -50%) rotate(45deg);
  border-radius: 18px;
  border: 1px solid rgba(150, 172, 204, 0.28);
}

.honors-section .container {
  position: relative;
  z-index: 2;
}

/* 人才招聘部分 */
.careers-section {
  background: linear-gradient(135deg, #f6f9ff 0%, #e6efff 100%);
  padding: 10px 0 30px;
}

.careers-entry {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 30px;
  background: white;
  border-radius: 16px;
  border: 2px solid #e7eefc;
  box-shadow: 0 10px 28px rgba(30, 85, 162, 0.12);
  padding: 28px;
  align-items: center;
}

.entry-left h3 {
  margin: 8px 0 10px 0;
  font-size: 22px;
  color: #1e55a2;
}

.entry-left p {
  margin: 0 0 16px 0;
  color: #555;
}

.entry-badge {
  display: inline-block;
  padding: 6px 10px;
  border-radius: 999px;
  background: linear-gradient(135deg, #4c95e3 0%, #1e55a2 100%);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
}

.entry-btn {
  display: inline-block;
  padding: 12px 18px;
  background: linear-gradient(135deg, #4c95e3 0%, #1e55a2 100%);
  color: #fff;
  border-radius: 10px;
  text-decoration: none;
  font-weight: 700;
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  box-shadow: 0 8px 20px rgba(30, 85, 162, 0.25);
}

.entry-btn:hover {
  transform: translateY(-2px);
  opacity: 0.95;
}

.entry-right .entry-figure {
  width: 100%;
  height: 180px;
  border-radius: 12px;
  background:
    radial-gradient(circle at 25% 35%, rgba(76,149,227,0.25), transparent 40%),
    radial-gradient(circle at 75% 65%, rgba(138,43,226,0.22), transparent 45%),
    linear-gradient(135deg, rgba(76,149,227,0.2), rgba(30,85,162,0.2));
  position: relative;
  overflow: hidden;
}

.entry-right .entry-figure::after {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(76,149,227,0.12) 1px, transparent 1px),
    linear-gradient(90deg, rgba(76,149,227,0.12) 1px, transparent 1px);
  background-size: 40px 40px;
  opacity: 0.8;
}

.entry-illustration_img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.12);
  transform: rotate(-2deg);
  animation: floatYS 4s ease-in-out infinite;
}
@keyframes floatYS {
  0%, 100% { transform: rotate(-2deg) translateY(10px); }
  50% { transform: rotate(-2deg) translateY(-10px); }
}

.entry-illustration {
  position: absolute;
  right: -10px;
  bottom: -10px;
  width: 70%;
  height: auto;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.12);
  transform: rotate(-2deg);
  animation: floatY 4s ease-in-out infinite;
}

.entry-figure::before {
  content: '';
  position: absolute;
  left: -30px;
  top: -30px;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(96,165,250,0.35), transparent 60%);
  filter: blur(2px);
  animation: floatX 6s ease-in-out infinite;
}

@keyframes floatY {
  0%, 100% { transform: rotate(-2deg) translateY(0); }
  50% { transform: rotate(-2deg) translateY(-6px); }
}

@keyframes floatX {
  0%, 100% { transform: translateX(0); }
  50% { transform: translateX(10px); }
}

@media (max-width: 768px) {
  .careers-entry {
    grid-template-columns: 1fr;
    padding: 22px;
  }
  .entry-right .entry-figure {
    height: 140px;
  }
  .entry-illustration {
    width: 80%;
    right: -6px;
    bottom: -8px;
  }
}

/* 联系我们部分 */
.contact-us-section {
  /* background: linear-gradient(135deg, #f6f9ff 0%, #e6efff 100%); */
  background-color: #fafafa;
  padding: 10px 0 20px;
}

.contact-us-content {
  /* background: white; */
  border-radius: 16px;
  /* border: 2px solid #e7eefc; */
  /* box-shadow: 0 10px 28px rgba(30, 85, 162, 0.12); */
  padding: 0px 20px;
  opacity: 0;
  display: flex;
  justify-content: space-between;
}

.company-info-section {
  margin-bottom: 0;
}

.company-name {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin: 0 0 20px 0;
  text-align: left;
}

.headquarters-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.headquarters-item {
  display: flex;
  align-items: flex-start;
  font-size: 16px;
  line-height: 1.8;
}

.headquarters-label {
  color: #333;
  font-weight: 600;
  min-width: 120px;
  flex-shrink: 0;
}

.headquarters-value {
  color: #333;
  flex: 1;
  text-decoration: none;
}

.headquarters-value[href] {
  color: #333333;
  transition: color 0.3s ease;
}

.headquarters-value[href]:hover {
  color: #1e55a2;
  text-decoration: underline;
}


.branches-section {
  margin-top: 0;
}

.branches-title {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin: 0 0 20px 0;
  text-align: left;
}

.branches-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.branch-item {
  display: flex;
  align-items: flex-start;
  font-size: 16px;
  line-height: 1.8;
}

.branch-name {
  color: #333;
  font-weight: 600;
  min-width: 140px;
  flex-shrink: 0;
}

.branch-address {
  color: #333;
  flex: 1;
}

@media (max-width: 768px) {
  .contact-us-content {
    padding: 25px 20px;
  }

  .company-name {
    font-size: 20px;
  }

  .headquarters-item,
  .branch-item {
    font-size: 15px;
    flex-direction: column;
    gap: 5px;
  }

  .headquarters-label,
  .branch-name {
    min-width: auto;
  }

  .branches-title {
    font-size: 18px;
  }
}

.honors-tabs {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 35px;
}

.honor-tab {
  padding: 10px 28px;
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 600;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
}

.honor-tab:hover {
  border-color: #4c95e3;
  color: #4c95e3;
  transform: translateY(-2px);
}

.honor-tab.active {
  background: linear-gradient(135deg, #4c95e3 0%, #1e55a2 100%);
  color: white;
  border-color: transparent;
  box-shadow: 0 4px 15px rgba(76, 149, 227, 0.3);
}

.honors-content {
  min-height: 250px;
}

.honors-empty {
  margin-top: 40px;
  padding: 40px 20px;
  text-align: center;
  color: rgba(255, 255, 255, 0.85);
  border: 1px dashed rgba(255, 255, 255, 0.3);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.05);
}

.certificates-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.certificates-photos {
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  max-width: 1000px;
  margin: 0 auto;
}

.certificate-photo-card {
  /* background: rgba(255,255,255,0.95); */
  backdrop-filter: blur(10px);
  padding: 8px;
  border-radius: 12px;
  text-align: center;
  /* box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.2); */
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  border: 2px solid transparent;
  position: relative;
  opacity: 0;
  overflow: hidden;
  max-width: 240px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.certificate-photo-card:hover {
  transform: translateY(-8px) scale(1.05);
  box-shadow: 0 12px 35px rgba(76, 149, 227, 0.25);
  border-color: #4c95e3;
}

.certificate-photo-card img {
  width: 140PX;
  height: AUTO;
  max-height: 220px;
  object-fit: contain;
  display: block;
  border-radius: 6px;
  transition: transform 0.3s ease;
}

.certificate-photo-card:hover img {
  transform: scale(1.03);
}

.certificate-name {
  margin-top: 15px;
  font-size: 15px;
  font-weight: 600;
  color: #333;
  text-align: center;
  line-height: 1.5;
  padding: 0 10px;
}

.certificate-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 30px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.2);
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  border: 2px solid transparent;
  position: relative;
  opacity: 0;
}

.certificate-card:hover {
  transform: translateY(-8px) scale(1.05);
  box-shadow: 0 12px 35px rgba(76, 149, 227, 0.25);
  border-color: #4c95e3;
}

.cert-icon {
  font-size: 48px;
  margin-bottom: 15px;
  filter: drop-shadow(0 4px 8px rgba(76, 149, 227, 0.3));
}

.certificate-card h3 {
  font-size: 18px;
  margin-bottom: 12px;
  color: #333;
  font-weight: 600;
}

.certificate-card p {
  color: #666;
  line-height: 1.6;
  font-size: 13px;
}

.cert-badge {
  position: absolute;
  top: 15px;
  right: 15px;
  background: linear-gradient(135deg, #4c95e3 0%, #1e55a2 100%);
  color: white;
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
}

/* 联系我们部分 */
.contact-section {
  background: linear-gradient(135deg, #e8f2fc 0%, #c5dff5 100%);
  padding: 10px 0;
}

.contact-grid {
  max-width: 900px;
  margin: 0 auto;
}

.contact-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 30px;
  opacity: 0;
}

.contact-item {
  background: white;
  padding: 30px;
  border-radius: 15px;
  display: flex;
  gap: 20px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.contact-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(76, 149, 227, 0.2);
}

.contact-icon {
  font-size: 40px;
  flex-shrink: 0;
}

.contact-details h3 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #333;
  font-weight: 600;
}

.contact-details a {
  color: #4c95e3;
  text-decoration: none;
  font-size: 16px;
  transition: all 0.3s ease;
}

.contact-details a:hover {
  color: #1e55a2;
  text-decoration: underline;
}

.contact-details p {
  color: #666;
  line-height: 1.6;
  font-size: 15px;
  margin: 0;
}

/* 客服热线部分 */
.customer-service-section {
  padding: 60px 0;
  position: relative;
  overflow: hidden;
  margin: 0;
}

.customer-service-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  height: 100%;
  background: linear-gradient(135deg, #4c95e3 0%, #1e55a2 50%, #00d4ff 100%);
  background-size: 200% 200%;
  animation: gradientShift 8s ease infinite;
  z-index: 0;
}

@keyframes gradientShift {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.service-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
  position: relative;
  z-index: 2;
}

.service-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 1;
}

.service-wave {
  position: absolute;
  bottom: -50px;
  left: -10%;
  width: 120%;
  height: 200px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  animation: waveAnimation 6s ease-in-out infinite;
}

.service-wave::before {
  content: '';
  position: absolute;
  bottom: -30px;
  left: -5%;
  width: 110%;
  height: 180px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  animation: waveAnimation 8s ease-in-out infinite reverse;
}

@keyframes waveAnimation {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(2deg); }
}

.service-dots {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(circle, rgba(255, 255, 255, 0.15) 2px, transparent 2px);
  background-size: 40px 40px;
  background-position: 0 0, 20px 20px;
  animation: dotsMove 20s linear infinite;
  opacity: 0.6;
}

@keyframes dotsMove {
  0% { background-position: 0 0, 20px 20px; }
  100% { background-position: 40px 40px, 60px 60px; }
}

.service-content-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
  position: relative;
  z-index: 2;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  padding: 50px 60px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.2);
}

.service-left-content {
  display: flex;
  align-items: center;
  gap: 30px;
  flex: 1;
}

.service-icon-wrapper {
  position: relative;
  flex-shrink: 0;
}

.service-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #4c95e3 0%, #1e55a2 100%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 10px 30px rgba(76, 149, 227, 0.4);
  position: relative;
  z-index: 2;
  animation: iconFloat 3s ease-in-out infinite;
}

@keyframes iconFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.service-icon-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  border: 2px solid rgba(76, 149, 227, 0.3);
  border-radius: 50%;
  animation: ringPulse 2s ease-in-out infinite;
}

@keyframes ringPulse {
  0% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
  100% { transform: translate(-50%, -50%) scale(1.3); opacity: 0; }
}

.service-text-content {
  flex: 1;
}

.service-main-title {
  font-size: 32px;
  font-weight: 700;
  color: #333;
  margin: 0 0 12px 0;
  line-height: 1.3;
}

.service-subtitle {
  font-size: 16px;
  color: #718096;
  margin: 0;
  line-height: 1.6;
}

.service-right-content {
  display: flex;
  align-items: center;
  gap: 30px;
  flex-shrink: 0;
}

.service-phone-wrapper {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 20px 30px;
  background: linear-gradient(135deg, rgba(76, 149, 227, 0.1) 0%, rgba(30, 85, 162, 0.1) 100%);
  border-radius: 16px;
  border: 2px solid rgba(76, 149, 227, 0.2);
}

.service-phone-icon {
  font-size: 32px;
  line-height: 1;
  animation: phoneRing 2s ease-in-out infinite;
}

@keyframes phoneRing {
  0%, 100% { transform: rotate(0deg); }
  10%, 30% { transform: rotate(-10deg); }
  20%, 40% { transform: rotate(10deg); }
  50% { transform: rotate(0deg); }
}

.service-phone-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.service-phone-label {
  font-size: 14px;
  color: #718096;
  font-weight: 500;
}

.service-phone-number {
  font-size: 24px;
  font-weight: 700;
  color: #1a202c;
  letter-spacing: 1px;
  background: linear-gradient(135deg, #4c95e3 0%, #1e55a2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.service-consult-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 32px;
  background: linear-gradient(135deg, #4c95e3 0%, #1e55a2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 10px 30px rgba(76, 149, 227, 0.4);
  position: relative;
  overflow: hidden;
}

.service-consult-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.service-consult-btn:hover::before {
  width: 300px;
  height: 300px;
}

.service-consult-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 40px rgba(76, 149, 227, 0.5);
}

.service-consult-btn:active {
  transform: translateY(0);
}

.service-consult-btn svg {
  position: relative;
  z-index: 1;
  transition: transform 0.3s ease;
}

.service-consult-btn:hover svg {
  transform: translateX(4px);
}

.service-consult-btn span {
  position: relative;
  z-index: 1;
}

/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Animista 动画 */
.animate-fade-in-up {
  opacity: 0;
  transform: translateY(40px);
  will-change: transform, opacity;
}

.animate-fade-in-up.is-visible {
  animation: fade-in-up 0.8s ease-out forwards;
}

.animate-slide-in-left {
  opacity: 0;
  transform: translateX(-150px);
  will-change: transform, opacity;
}

.animate-slide-in-left.is-visible {
  animation: slide-in-left 1s ease-out forwards;
}

.animate-slide-in-right {
  opacity: 0;
  transform: translateX(150px);
  will-change: transform, opacity;
}

.animate-slide-in-right.is-visible {
  animation: slide-in-right 1s ease-out forwards;
}

.animate-zoom-in {
  opacity: 0;
  transform: scale(0.8);
  will-change: transform, opacity;
}

.animate-zoom-in.is-visible {
  animation: zoom-in 0.8s ease-out forwards;
}

@keyframes fade-in-up {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slide-in-left {
  from {
    opacity: 0;
    transform: translateX(-150px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slide-in-right {
  from {
    opacity: 0;
    transform: translateX(150px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes zoom-in {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes kenburns-top {
  0% {
    transform: scale(1) translateY(0);
    transform-origin: 50% 16%;
  }
  100% {
    transform: scale(1.25) translateY(-15px);
    transform-origin: top;
  }
}

@media (max-width: 768px) {
  .section-title {
    font-size: 28px;
  }

  .timeline-container {
    padding: 120px 40px 120px;
    min-height: 600px;
  }

  .timeline-line {
    left: 40px;
    right: 40px;
  }

  .timeline-item {
    transform: translate(-50%, -50%);
  }

  .timeline-connector {
    height: 100px;
  }

  .timeline-item.top .timeline-content {
    bottom: 120px;
    width: 180px;
  }

  .timeline-item.bottom .timeline-content {
    top: 120px;
    width: 180px;
  }

  .timeline-year {
    font-size: 18px;
  }

  .timeline-description {
    font-size: 12px;
  }

  .culture-section {
    padding: 60px 0;
  }

  .culture-section-title {
    font-size: 28px;
  }

  .culture-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .culture-item {
    height: 400px;
  }

  .culture-item-title {
    font-size: 20px;
  }

  .culture-mission,
  .culture-vision {
    font-size: 15px;
  }

  .honors-tabs {
    flex-direction: column;
    align-items: center;
  }

  .honor-tab {
    width: 160px;
    padding: 8px 20px;
    font-size: 13px;
  }

  .certificates-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .certificates-photos {
    grid-template-columns: 1fr;
  }

  .certificate-photo-card {
    padding: 8px;
    max-width: 200px;
  }

  .certificate-photo-card img {
    max-height: 180px;
  }

  .customer-service-section {
    padding: 40px 0;
  }

  .service-container {
    padding: 0 20px;
  }

  .service-content-wrapper {
    flex-direction: column;
    gap: 30px;
    padding: 30px 20px;
    border-radius: 16px;
  }

  .service-left-content {
    flex-direction: column;
    text-align: center;
    gap: 20px;
    width: 100%;
  }

  .service-icon-wrapper {
    margin: 0 auto;
  }

  .service-icon {
    width: 60px;
    height: 60px;
  }

  .service-icon svg {
    width: 36px;
    height: 36px;
  }

  .service-main-title {
    font-size: 24px;
  }

  .service-subtitle {
    font-size: 14px;
  }

  .service-right-content {
    flex-direction: column;
    width: 100%;
    gap: 20px;
  }

  .service-phone-wrapper {
    width: 100%;
    justify-content: center;
    padding: 15px 20px;
  }

  .service-phone-number {
    font-size: 20px;
  }

  .service-consult-btn {
    width: 100%;
    justify-content: center;
    padding: 14px 28px;
  }

  .contact-info {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 992px) {
  .honors-shape--triangle {
    width: 180px;
    height: 180px;
    right: 6%;
    opacity: 0.8;
  }

  .honors-shape--circle {
    width: 220px;
    height: 220px;
    bottom: -110px;
    opacity: 0.8;
  }

  .honors-shape--diamond {
    width: 160px;
    height: 160px;
    opacity: 0.8;
  }
}

@media (max-width: 768px) {
  .honors-section {
    padding: 50px 0;
  }

  .honors-shape--triangle {
    width: 140px;
    height: 140px;
    top: -20px;
    opacity: 0.75;
  }

  .honors-shape--circle {
    width: 180px;
    height: 180px;
    left: 5%;
    bottom: -90px;
    opacity: 0.75;
  }

  .honors-shape--diamond {
    width: 130px;
    height: 130px;
    top: 30%;
    opacity: 0.75;
  }
}

/* 客户案例区域 */
.customers-section {
  background: #ffffff;
  padding: 20px 0;
  position: relative;
}

.customers-header {
  text-align: left;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
}

.customers-section-title {
  font-size: 32px;
  font-weight: 700;
  color: #333;
  margin: 0 0 15px 0;
  padding-bottom: 20px;
  position: relative;
  z-index: 1;
}

.customers-section .section-title {
  text-align: left;
}

.customers-section .section-title::after {
  left: 0;
  transform: none;
}

.customers-subtitle {
  text-align: left;
  font-size: 16px;
  color: #666;
  font-style: italic;
  opacity: 1;
  line-height: 1.8;
  max-width: 900px;
  margin: 0;
  padding: 0;
  position: relative;
  z-index: 1;
}

.customers-content {
  display: flex;
  flex-direction: column;
  /* gap: 30px; */
}

.customer-category {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 24px 28px 28px 28px;
  /* background: linear-gradient(145deg, rgba(76, 149, 227, 0.08), rgba(30, 85, 162, 0.05)); */
  /* border-radius: 18px; */
  /* border: 1px solid rgba(76, 149, 227, 0.25); */
  /* box-shadow: 0 20px 45px rgba(17, 45, 102, 0.12); */
}

.customer-category-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 700;
  color: #1e55a2;
  margin-bottom: 18px;
  padding-bottom: 12px;
  border-bottom: 1px dashed rgba(30, 85, 162, 0.3);
}

.customer-category-icon {
  width: 54px;
  height: 54px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(76, 149, 227, 0.15), rgba(30, 85, 162, 0.15));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #4c95e3;
  box-shadow: inset 0 0 0 1px rgba(76, 149, 227, 0.2);
  flex-shrink: 0;
  transition: background 0.3s ease, color 0.3s ease;
}

.customer-category-title:hover .customer-category-icon {
  background: linear-gradient(135deg, rgba(76, 149, 227, 0.25), rgba(30, 85, 162, 0.25));
  color: #1e55a2;
}

.customer-category-icon .iconfont {
  font-size: 28px;
  line-height: 1;
}

.customer-text-list {
  column-count: 3;
  column-gap: 30px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.customer-text-item {
  font-size: 15px;
  color: #4a4a4a;
  line-height: 1.8;
  margin-bottom: 6px;
  break-inside: avoid;
  position: relative;
  padding-left: 12px;
}

.customer-text-item::before {
  content: '•';
  position: absolute;
  left: 0;
  color: #4c95e3;
  font-weight: bold;
}

.customer-text-item:hover {
  color: #1e55a2;
}

@media (max-width: 992px) {
  .customer-text-list {
    column-count: 2;
  }

  .customer-category-title {
    font-size: 18px;
  }
}

@media (max-width: 768px) {
  .customers-section {
    padding: 60px 0;
  }

  .customers-section-title {
    font-size: 28px;
  }

  .customers-subtitle {
    font-size: 15px;
  }

  .customer-category-title {
    font-size: 16px;
  }

  .customer-text-list {
    column-count: 1;
  }

  .customer-text-item {
    font-size: 14px;
  }
}

/* 关于企业介绍板块 */
.about-intro-section {
  background: #f5f5f5;
  padding: 20px 0;
  position: relative;
}

.about-intro-content {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.about-intro-text {
  text-align: left;
}

.about-intro-subtitle {
  font-size: 16px;
  color: #999999;
  font-weight: 400;
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.about-intro-title {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 30px 0;
  line-height: 1.4;
}

.about-intro-description {
  font-size: 16px;
  color: #333333;
  line-height: 1.8;
  margin: 0;
  margin-bottom: 10px;
  text-indent: 2em;
}

@media (max-width: 992px) {
  .about-intro-title {
    font-size: 24px;
  }
}

@media (max-width: 768px) {
  .about-intro-section {
    padding: 60px 0;
  }

  .about-intro-title {
    font-size: 20px;
  }

  .about-intro-description {
    font-size: 15px;
  }
}
</style>


